module.exports = {"TXTWCL_All_Clubs":{"id":"TXTWCL_All_Clubs","defaultMessage":"Tutti i club","track":"All Clubs"}}